import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

export default function PageTabs({ pages, activePageId, onPageChange }) {
  const handleChange = (event, newValue) => {
    onPageChange(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
      <Tabs value={activePageId} onChange={handleChange} aria-label="portal pages">
        {pages.map((page) => (
          <Tab
            key={page.id}
            label={
              <span>
                {page.icon && <span style={{ marginRight: 6 }}>{page.icon}</span>}
                {page.name}
              </span>
            }
            value={page.id}
          />
        ))}
      </Tabs>
    </Box>
  );
}
